module.exports = __webpack_public_path__ + "img/sarpras-dashboard.a9271b8e.png";